// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import SearchController from "./search_controller"
import AccordionController from "./accordion_controller"
import ControlMatrixController from "./control_matrix_controller"
import LocaleSwitcherController from "./locale_switcher_controller"

application.register("hello",           HelloController)
application.register("search",          SearchController)
application.register("accordion",       AccordionController)
application.register("control-matrix",  ControlMatrixController)
application.register("locale-switcher", LocaleSwitcherController)
